import basicController from "servicestack/basic.controller.properties";
import templateUrl from "emun.salesrep/territory-manager/repgroup/repgroup-edit.htm";
import AutoQuery from "servicestack/auto-query/auto-query";
import resolve from "ioc/resolve";
import modals from 'webmodals/modals'
import PriceListPicker from 'emun.salesrep/territory-manager/repgroup/pricelist-picker'
import ServiceBus from "servicestack/service-bus";

class RepGroupEditController {
	constructor() {
		const $ctrl = this;
		basicController($ctrl);
	}
	$onInit() {
		const $ctrl = this;
		const id = $ctrl.repgroupId;
		$ctrl.bus = new ServiceBus();
		if (id == "create") {
			$ctrl.repgroup = { id: "", showOnDashboard: false };
			$ctrl.showId = true;
		} else {
			let options = {
				url: "QueryRepGroups.json?Id=" + id,
				autoLoad: true,
				append: false,
				pageSize: 24,
				onLoaded: args => {
					$ctrl.repgroup = args.first;
				}
			};
			$ctrl.query = new AutoQuery(options);
		}
		$ctrl.divisions = new AutoQuery({
			url: "QueryDivisions.json",
			criteria: {
				RepGroup: id
			},
			autoLoad: true
		});
		$ctrl.salesreps = new AutoQuery({
			url: "QuerySalesReps.json",
			criteria: {
				RepGroupId: id
			},
			autoLoad: true
		});
		$ctrl.pricelists = new AutoQuery({
			url: "QueryPriceLists.json?GroupBy=PriceListId",
			criteria: {
				RepGroupId: id
			},
			autoLoad: true
		});
	}
	submit(close) {
		const $ctrl = this;
		const action = `${$ctrl.showId ? "Cre" : "Upd"
			}ateRepGroup.json`;

		return $ctrl.bus.send(action, $ctrl.repgroup)
		.then((res) => {
			$ctrl.repgroupId = res.data.id;
			$ctrl.repgroup.id = res.data.id;
			$ctrl.divisions.criteria.RepGroup = $ctrl.repgroup.id;
			$ctrl.salesreps.criteria.RepGroupId = $ctrl.repgroup.id;
			if (close) resolve("$state").go("repgroups");
		}).catch((err) => {
			console.error(err);
			alert("Error saving Rep Group.  Make sure you filled out ID and Name");
		});
	}

	addPriceList() {
		let $ctrl = this;
		$ctrl.repIds = [];

		return PriceListPicker({
			title: "Select Price Lists...",
			subTitle: "",
			applyTagsButtonText: false,
			single: false,
			viewSelections: false,
		}).then((result) => {
			$ctrl.bus.send("AddRepGroupPriceLists", {
				RepGroupId: $ctrl.repgroup.id,
				ListIds: result
			}).then(function (response) {
				$ctrl.pricelists.load();
			});
		});
	}
	deletePriceList(list) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to remove " + list.priceListId, "Remove Price List?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteRepGroupPriceList.json", {
						RepGroupId: $ctrl.repgroup.id,
						PriceListId: list.priceListId
					})
					.then(function () {
						return $ctrl.pricelists.load(true);
					})
					.catch(

					);
			});
	}

}

let RepGroupEdit = {
	controller: RepGroupEditController,
	bindings: {
		repgroupId: "@"
	},
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};

export default RepGroupEdit;
